var mentions_default = {
  "mentionPalette": "rTrFZ",
  "mention": "ICUJV",
  "mentionViewer": "ci7Hg",
  "mentionSuggestionsEntry": "J5psL",
  "mentionSuggestionsEntryFocused": "eabEE",
  "mentionSuggestionsEntryText": "HYwu6",
  "mentionSuggestionsEntryAvatar": "aHPoF",
  "mentionSuggestions": "_6LAW7",
  "cursorDefault": "jlGIs",
  "cursorPointer": "kfgwo"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
